import { domain } from 'modules/data';

export const getSSOMethodForAnalytics = (provider: domain.OAuthProvider) => {
    switch (provider) {
        case domain.OAuthProvider.Xero:
            return 'xero_sso';

        case domain.OAuthProvider.QBooks:
            return 'qbo_sso';

        case domain.OAuthProvider.Google:
            return 'google_sso';

        case domain.OAuthProvider.Microsoft:
            return 'microsoft_sso';

        default:
            return provider;
    }
};
